export default __webpack_public_path__ + "static/media/marketplace.e9f48e80.svg";